import { render, staticRenderFns } from "./appointment_administrative_show.vue?vue&type=template&id=d8bab11c"
import script from "./appointment_administrative_show.vue?vue&type=script&lang=js"
export * from "./appointment_administrative_show.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports